import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BillService } from '../../../shared/services/bill.service';
import { SessionService } from '../../../shared/services/session.service';
import { Session } from '../../../shared/types/session';

@Component({
    selector: 'las-bill-search-modal',
    templateUrl: './bill-search-modal.component.html',
    styleUrls: ['./bill-search-modal.component.scss'],
    standalone: false,
})
export class BillSearchModalComponent implements OnInit {
    sessions: Session[] = <Session[]>[];
    results: any[] = [];

    isLoading: boolean = false;

    searchForm = this.fb.group({
        session: [''],
        text: ['', Validators.required],
    });

    /*
     * Initializes form data with injected data
     */
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { session: string; text: string },
        public dialogRef: MatDialogRef<BillSearchModalComponent>,
        private sessionService: SessionService,
        private billService: BillService,
        private fb: FormBuilder,
    ) {}

    /*
     * Initializes component
     */
    ngOnInit(): void {
        this.searchForm.patchValue({
            session: this.data.session,
            text: this.data.text,
        });

        this.getSessions();

        if (this.data.text) {
            this.search();
        }
    }

    /*
     * Get All sessions for Search Dropdown
     */
    getSessions() {
        this.sessionService.getSessions().subscribe((result) => {
            this.sessions = result;
        });
    }

    /*
     * Search Bills by Text and Sessions
     */
    search() {
        const session = this.searchForm.value['session'] ?? '';
        const searchText = this.searchForm.value['text'] ?? '';

        this.isLoading = true;

        if (session === '') {
            this.billService.searchBills(searchText).subscribe((result) => {
                this.results = result;
                this.isLoading = false;
            });
        } else {
            this.billService
                .searchBillsBySession(searchText, session)
                .subscribe((result) => {
                    this.results = result;
                    this.isLoading = false;
                });
        }
    }

    public closePopup(): void {
        this.dialogRef.close();
    }
}
